(function () {
  "use strict";

  angular.module("sempraWebapp").factory("deviceActions", deviceActionsFactory);

  /** @ngInject */
  function deviceActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getDevices: getDevices,
      getDeviceBySerialNumber: getDeviceBySerialNumber,
      getAllDevices: getAllDevices,
      getDeviceDetails: getDeviceDetails,
      updateDeviceDetails: updateDeviceDetails,
      getDevice: getDevice,
      actuate: actuate,
      getDeviceWorkingHours: getDeviceWorkingHours,
      updateDeviceWorkingHours: updateDeviceWorkingHours,
      groupActuate: groupActuate,
      getHistoryOfActuatedPointsByDeviceKey:
        getHistoryOfActuatedPointsByDeviceKey,
      getPointsListByDeviceKey: getPointsListByDeviceKey,
      changeDeviceLabelName: changeDeviceLabelName
    };

    function getAllDevices() {
      var deferred = $q.defer();
      api.getDevices().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDeviceDetails(deviceId) {
      var deferred = $q.defer();
      api.getDeviceDetails(deviceId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function updateDeviceDetails(deviceId, data) {
      var deferred = $q.defer();
      api.updateDeviceDetails(deviceId, data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDevice(deviceSerial) {
      var deferred = $q.defer();
      api.getDeviceBySerialNumber(deviceSerial).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function actuate(deviceSerial, data) {
      var deferred = $q.defer();
      api.actuate(deviceSerial, data).then(
        function () {
          deferred.resolve();
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDevices() {
      api.getDevices().then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DEVICES,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }

    function getDeviceBySerialNumber(serialNumber) {
      api.getDeviceBySerialNumber(serialNumber).then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DEVICE,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }

    function getDeviceWorkingHours(pointId) {
      var deferred = $q.defer();
      api.getDeviceWorkingHours(pointId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function updateDeviceWorkingHours(pointId, data) {
      var deferred = $q.defer();
      api.updateDeviceWorkingHours(pointId, data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function groupActuate(deviceKey, pointId, data) {
      var deferred = $q.defer();
      api.groupActuate(deviceKey, pointId, data).then(
        function () {
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("ACTUATION_SUCCESS")
            }
          });
          deferred.resolve();
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getHistoryOfActuatedPointsByDeviceKey(
      deviceKey,
      pointIds,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getHistoryOfActuatedPointsByDeviceKey(
          deviceKey,
          pointIds,
          page,
          pageSize,
          orderBy,
          order
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getPointsListByDeviceKey(deviceKet) {
      var deferred = $q.defer();
      api.getPointsListByDeviceKey(deviceKet).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function changeDeviceLabelName(deviceData) {
      var deferred = $q.defer();
      api.changeDeviceLabelName(deviceData).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }
  }
})();
